module.exports = __webpack_public_path__ + "static/media/ebbae8ae-2cd5-43e9-be98-ef1f69def547.35c77d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/ebbae8ae-2cd5-43e9-be98-ef1f69def547.png
// module id = 1466
// module chunks = 0